import { Link } from 'react-router-dom';
import { getFolderLink, getWorkbooksLink } from '@/main/routing.utilities';
import { translateBreadcrumb } from '@/utilities/homescreen.utilities';
import type { WorkbookItemPreview } from '@/workbook/workbook.constants';

interface HeaderBreadcrumbsProps {
  breadcrumbs: WorkbookItemPreview[];
  isWorksheetDisplayed: boolean;
}

export const HeaderBreadcrumbs = ({ breadcrumbs, isWorksheetDisplayed }: HeaderBreadcrumbsProps) => {
  const getLink = (crumb: WorkbookItemPreview) =>
    crumb.id && !crumb.tabHash ? getFolderLink(crumb.id) : getWorkbooksLink(crumb.tabHash);

  return (
    <div className="flexColumnContainer tw:min-w-0 tw:flex-initial tw:items-center tw:justify-center tw:overflow-hidden">
      {!!breadcrumbs.length && isWorksheetDisplayed && (
        <span className="fs11 tw:mt-0 tw:mb-0.5">
          <ul className="unstyled-list flexColumnContainer headerBreadcrumbs folderBreadcrumbs tw:mt-0 tw:mb-0 tw:flex-initial tw:font-normal">
            {breadcrumbs.map((crumb) => (
              <li key={`crumbId_${crumb.id}`}>
                <Link to={getLink(crumb)}>{translateBreadcrumb(crumb)}</Link>
              </li>
            ))}
          </ul>
        </span>
      )}
    </div>
  );
};
